import request from "../utils/request";

export const process = () => request.get("/api/dashboard/process");
export const stats = () => request.get("/api/dashboard/stats");

export const dashboard = (data) => request.get("/api/general/dashboard", data);
export const impression = (data) => request.get("/api/general/impression", data);